import { ConfigHelper } from './../../app/helpers/configHelper';
import { AlertProvider } from './../alert/alert';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpResultModel } from '../../app/models/HttpResultModel';
import { SpinnerProvider } from '../spinner/spinner';
import { NetworkProvider } from '../network/network';
import { ConcessionariaModel } from '../../app/models/ConcessionariaModel';
import { Storage } from '@ionic/storage';
// import { Observable } from 'rxjs/Observable';
// import { HTTP } from '@ionic-native/http';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';
import {
  timeout
} from 'rxjs/operators';


@Injectable()
export class HttpProvider {
  contador = 0;
  concessionaria: ConcessionariaModel;
  codUsuario:any =  "";
  nomeUsuario:any = "";
  nivelUsuario:any = "";
  codConcessionaria:any = "";
  versao:any = "";
  
  // Variáveis para sincronização de horário
  private offsetServidor: number = 0;
  private _ultimaSincronizacao: Date;

  constructor(
    private http: HttpClient,
    //private httpNativo: HTTP,
    public storage: Storage,
    private spinnerSrv: SpinnerProvider,
    private alertSrv: AlertProvider,
    private networkSrv: NetworkProvider,
  ) {
    this.contador = 0;

  }

  // Método para sincronizar horário com o servidor
  sincronizarHorario(headers: any): void {
    try {
      const dateHeader = headers.get('Date') || headers.get('date');
      if (dateHeader) {
        const horarioServidor = new Date(dateHeader);
        const horarioLocal = new Date();
        
        this.offsetServidor = horarioServidor.getTime() - horarioLocal.getTime();
        this._ultimaSincronizacao = horarioLocal;
        
      }
    } catch (error) {
      console.log('⚠️ Erro ao sincronizar horário:', error);
    }
  }

  // Método para obter horário sincronizado
  getHorarioSincronizado(): Date {
    return new Date(new Date().getTime() + this.offsetServidor);
  }

  // Método público para obter offset (para uso em outros componentes)
  getOffsetServidor(): number {
    return this.offsetServidor;
  }

  // Método público para obter a data/hora da última sincronização
  getUltimaSincronizacao(): Date {
    return this._ultimaSincronizacao;
  }

  usuarioLogado(){
    let valor = this.storage.get(ConfigHelper.storageKeys.concessionaria);
    valor.then(async (val) => {
      if(val){
        this.concessionaria = JSON.parse(val);
      }
    });
    if(this.concessionaria){
        if(this.concessionaria.nivel==0){
          this.nomeUsuario = this.concessionaria.nomeFantasia;
          this.codUsuario = this.concessionaria.codConcessionaria;
        }else if(this.concessionaria.nivel==1){
          this.nomeUsuario = this.concessionaria.consultor;
          this.codUsuario = this.concessionaria.cod_consultor;
        }else if(this.concessionaria.nivel==2){
          this.nomeUsuario = this.concessionaria.mecanico;
          this.codUsuario = this.concessionaria.cod_mecanico;
        }
        this.nivelUsuario = this.concessionaria.nivel;
        this.codConcessionaria = this.concessionaria.codConcessionaria;
    }
  }

  createHeader(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('TOKEN', ConfigHelper.Token);
    this.usuarioLogado();
    header = header.set('codUsuario', this.codUsuario);
    header = header.set('nomeUsuario', this.nomeUsuario);
    header = header.set('nivelUsuario', this.nivelUsuario);
    header = header.set('codConcessionaria', this.codConcessionaria);
    header = header.set('versao', ConfigHelper.Version);

    return header;
  }

  createHeaderDms(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('Token', ConfigHelper.TokenDms);

    return header;
  }

  createHeaderCamp(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('token', 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855');
    header = header.set('Content-Type', 'application/json');
    this.usuarioLogado();
    header = header.set('codUsuario', this.codUsuario);
    header = header.set('nomeUsuario', this.nomeUsuario);
    header = header.set('nivelUsuario', this.nivelUsuario);
    header = header.set('codConcessionaria', this.codConcessionaria);
    header = header.set('versao', ConfigHelper.Version);
    return header;
  }

  createHeaderStorage(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    header = header.set('Token', ConfigHelper.TokenStorage);
    this.usuarioLogado();
    header = header.set('codUsuario', this.codUsuario);
    header = header.set('nomeUsuario', this.nomeUsuario);
    header = header.set('nivelUsuario', this.nivelUsuario);
    return header;
  }


  createHeaderChecklist(header?: HttpHeaders, codigoLogin:string =""): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    // console.log("codigoLogin2", codigoLogin)
    header = header.set('Token', ConfigHelper.TokenChecklist);
    header = header.set('login', codigoLogin);    
    this.usuarioLogado();
    header = header.set('codUsuario', this.codUsuario);
    header = header.set('nomeUsuario', this.nomeUsuario);
    header = header.set('nivelUsuario', this.nivelUsuario);
    header = header.set('codConcessionaria', this.codConcessionaria);
    header = header.set('versao', ConfigHelper.Version);


    return header;
  }

  createHeaderPesquisa(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    this.usuarioLogado();
    header = header.set('codUsuario', this.codUsuario);
    header = header.set('nomeUsuario', this.nomeUsuario);
    header = header.set('nivelUsuario', this.nivelUsuario);
    header = header.set('codConcessionaria', this.codConcessionaria);
    header = header.set('versao', ConfigHelper.Version);

    header = header.set('token', ConfigHelper.TokenPesquisa);

    return header;
  }
  createHeaderAgendamento(header?: HttpHeaders): HttpHeaders {
    if (!header) {
      header = new HttpHeaders();
    }
    this.usuarioLogado();
    // header = header.set('Access-Control-Allow-Origin', '*');
    header = header.set('nomeUsuario', this.nomeUsuario);
    header = header.set('nivelUsuario', this.nivelUsuario);
    header = header.set('codUsuario', this.codUsuario);
    header = header.set('codConcessionaria', this.codConcessionaria);
    header = header.set('versao', ConfigHelper.Version);

    return header;
  }

  // createHeader(): HttpHeaders {

  //   const headers = new HttpHeaders().set("TOKEN", ConfigHelper.Token);

  //   return headers;
  // }

  get(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise<HttpResultModel> {

    let header = this.createHeader();
    let _url = ConfigHelper.Url + url;
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem, tempoSpinner);
        }

        this.http.get(_url, { headers: header }).pipe(
          timeout(timeOut)
        )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {

            console.log('deu erro');
            if (err.status != 404) {
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            }

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err == "TimeoutError: Timeout has occurred") {
              if (loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                '',
                'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                );
              }
            }

            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  curlGet(_url: string, header: HttpHeaders, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise<HttpResultModel> {

    if(header === null) {
      header = this.createHeaderPesquisa();
    }
    // let _url = url;
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem, tempoSpinner);
        }

        this.http.get(_url, { headers: header }).pipe(
          timeout(timeOut)
        )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {

            console.log('deu erro');
            if (err.status != 404) {
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            }

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err == "TimeoutError: Timeout has occurred") {
              if (loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }
            }

            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  curlPost(_url: string, header: HttpHeaders, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000): Promise<HttpResultModel> {

    if(header === null) {
      header = this.createHeaderPesquisa();
    }

    return new Promise((resolve) => {

      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //console.log('erro status',err);

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro',msg,'Problema ao Salvar');
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
            )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  curlPostFormData(_url: string, header: HttpHeaders, model: FormData, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000): Promise<HttpResultModel> {

    if(header === null) {
      header = this.createHeaderPesquisa();
    }

    return new Promise((resolve) => {

      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //console.log('erro status',err);

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro',msg,'Problema ao Salvar',);
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );  
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }


  curlPreOrdemChecklist(_url: string, model: FormData, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000): Promise<HttpResultModel> {
    
    let header = new HttpHeaders();

    return new Promise((resolve) => {

      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header, responseType: 'blob' })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            this.spinnerSrv.Hide();
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  getChecklist(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise<HttpResultModel> {

    let header = this.createHeaderChecklist();
    let _url = ConfigHelper.Url + url;
    // let _url = "https://dev-acampa-checklist.azurewebsites.net/" + 'api/' + url;
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem, tempoSpinner);
        }

        this.http.get(_url, { headers: header }).pipe(
          timeout(timeOut)
        )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {

            console.log('deu erro');
            if (err.status != 404) {
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            }

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err == "TimeoutError: Timeout has occurred") {
              if (loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
  
              }
            }

            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
      )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  getLocal(url: string): Promise<HttpResultModel> {

    let header = this.createHeader();
    let _url = url;
    //console.log(_url);

    return new Promise((resolve) => {

      this.http.get(_url, { headers: header })
        .subscribe(_res => {
          //let json = JSON.parse(_res.data);
          resolve({ success: true, data: _res, err: undefined });
        }, err => {
          if (err.status != 404) {
            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
          }

          //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
          resolve({ success: false, data: undefined, err: err });
        });

    });
  }

  getDms(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", alerta_sem_conexao: boolean = true, tentativas: number = 3, timeOut: number = 15000): Promise<HttpResultModel> {

    let header = this.createHeaderDms();
    let _url = url + "/" + ConfigHelper.Distribuidor;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.get(_url, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {


            this.contador += 1;
            if (this.contador < tentativas) {
              return resolve(this.getDms(url, loading, "Reconectando " + this.contador + "...",alerta_sem_conexao));
            }


            if (this.contador >= tentativas) {
              this.contador = 0;
              if (loading == 1) {
                console.log("alerta_sem_conexao", alerta_sem_conexao)
                if(alerta_sem_conexao)   this.alertSrv.newAlert('erro','Sem conexão com o Servidor', '','Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');

                this.spinnerSrv.Hide();
              }
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
              resolve({ success: false, data: undefined, err: err });
            }
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
        )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }


  postDmsCamp(url: string, model: any, loading: number = 1, mensagem: string = "Carregando os dados...", alerta_sem_conexao: boolean = true, tentativas: number = 3, timeOut: number = 30000): Promise<HttpResultModel> {

    let _url = ConfigHelper.UrlIntergracao + url;
    let header = this.createHeaderCamp();

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {


            this.contador += 1;
            if (this.contador < tentativas) {
              return resolve(this.postDmsCamp(url, model, loading, "Reconectando " + this.contador + "...",alerta_sem_conexao));
            }


            if (this.contador >= tentativas) {
              this.contador = 0;
              if (loading == 1) {
                console.log("alerta_sem_conexao", alerta_sem_conexao)
                if(alerta_sem_conexao)  this.alertSrv.newAlert('erro','Sem conexão com o Servidor', '','Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
  
                this.spinnerSrv.Hide();
              }
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
              resolve({ success: false, data: undefined, err: err });
            }
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
        )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  post(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000): Promise<HttpResultModel> {

    let header = this.createHeader();
    let _url = ConfigHelper.Url + url;

    return new Promise((resolve) => {

      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //console.log('erro status',err);

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro', msg,'Problema ao Salvar');
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  postChecklist(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000, apiURL: boolean = true,codigoLogin: string = ""): Promise<HttpResultModel> {

    // let _url = "https://dev-acampa-checklist.azurewebsites.net/" + 'api/' + url;
    let header;
    let _url;
    let options;
    if(apiURL){
      header = this.createHeaderChecklist(new HttpHeaders(), codigoLogin);
      _url = ConfigHelper.Url + url;
      options = { headers: header};
    } else {
      header = this.createHeaderAgendamento();
      _url = ConfigHelper.Url + url;
      options = { headers: header, responseType: "blob"};
    }

    console.log('url savando',_url);

    return new Promise((resolve) => {

      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, options)
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro',msg,'Problema ao Salvar',);
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  postChecklistAgendamento(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000, apiURL: boolean = true,codigoLogin: string = ""): Promise<HttpResultModel> {

    // let _url = "https://dev-acampa-checklist.azurewebsites.net/" + 'api/' + url;
    let header;
    let _url;
    let options;
    if(apiURL){
      header = this.createHeaderChecklist(new HttpHeaders(), codigoLogin);
      _url = ConfigHelper.UrlCheckList + url;
      options = { headers: header};
    } else {
      header = this.createHeaderAgendamento();
      _url = ConfigHelper.UrlCheckList + url;
      options = { headers: header, responseType: "blob"};
    }

    console.log('url savando',_url);

    return new Promise((resolve) => {

      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, options)
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro', msg,'Problema ao Salvar');
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  put(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000): Promise<HttpResultModel> {

    let header = this.createHeader();
    let _url = ConfigHelper.Url + url;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.put(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            console.log("_res", _res);
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            console.log('erro status', err);

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro', msg,'Problema na Atualização');
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }


  putChecklist(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000, codigoLogin: string = ""): Promise<HttpResultModel> {

    console.log("codigoLogin",codigoLogin)
    let header = this.createHeaderChecklist(new HttpHeaders(), codigoLogin);
    let _url = ConfigHelper.Url + url;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.put(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            console.log("_res", _res);
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            console.log('erro status', err);

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro',msg,'Problema na Atualização');
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }


  delete(url: string, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 15000, codigoLogin: string = ""): Promise<HttpResultModel> {

    let header = this.createHeaderChecklist(new HttpHeaders(), codigoLogin);
    let _url = ConfigHelper.Url + url;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.delete(_url, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            console.log("_res", _res);
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            console.log('erro status', err);

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  deleteFormulario(url: string, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 15000, codigoLogin: string =""): Promise<HttpResultModel> {

    let header = this.createHeaderChecklist(new HttpHeaders(), codigoLogin);
    let _url = ConfigHelper.Url + url;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.delete(_url, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            console.log("_res", _res);
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            console.log('erro status', err);

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  postDms(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 290000): Promise<HttpResultModel> {

    let header = this.createHeaderDms();
    let _url = "https://dms.camptecnologia.com.br/" + url + "/" + ConfigHelper.Distribuidor;

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            console.log('erro status', err);

            if (verconexao == 1 && loading == 1) {
              this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                '',
                'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                );
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  getCamp(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise<HttpResultModel> {

    let header = this.createHeaderCamp();
    let _url = ConfigHelper.Url + url;
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem, tempoSpinner);
        }

        this.http.get(_url, { headers: header }).pipe(
          timeout(timeOut)
        )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {

            console.log('deu erro');
            if (err.status != 404) {
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            }

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err == "TimeoutError: Timeout has occurred") {
              if (loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                );
              }
            }

            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
        )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }


  postCamp(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 290000): Promise<HttpResultModel> 
  {

    // url vai mudar teremos que ver como vamos aplicar pois a url sera por distribuidor
    // ConfigHelper.Distribuidor
    let _url = ConfigHelper.Url + url;
    let header = this.createHeaderCamp();

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, { headers: header, observe: 'response' })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(response => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            
            // Sincroniza horário com o header Date da resposta
            this.sincronizarHorario(response.headers);
            
            //let json = JSON.parse(response.body.data);
            resolve({ success: true, data: response.body, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            console.log('erro status', err);

            if (verconexao == 1 && loading == 1) {
              this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                '',
                'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
              );
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }


  postStorage(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 190000): Promise<HttpResultModel> {

    let header = this.createHeaderStorage();

    let _url = ConfigHelper.UrlStorage + url + "/" + ConfigHelper.Distribuidor;
    
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, JSON.stringify(model), { headers: header })
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            console.log('erro status', err);

            if (verconexao == 1 && loading == 1) {
              this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                '',
                'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
              );
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }

  getSASToken(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise<HttpResultModel> {

    let header = this.createHeaderChecklist();
    let _url = ConfigHelper.Url + url;
    // let _url = "https://dev-acampa-checklist.azurewebsites.net/" + 'api/' + url;
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem, tempoSpinner);
        }

        this.http.get(_url, { headers: header }).pipe(
          timeout(timeOut)
        )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {

            console.log('deu erro');
            if (err.status != 404) {
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            }

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err == "TimeoutError: Timeout has occurred") {
              if (loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                );
              }
            }

            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
        )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  getChecklistStellantis(url: string, loading: number = 1, mensagem: string = "Carregando os dados...", tempoSpinner: number = null, timeOut: number = 15000): Promise<HttpResultModel> {

    let header = this.createHeaderChecklist();
    let _url = ConfigHelper.Url + url;
    // let _url = "https://dev-acampa-checklist.azurewebsites.net/" + 'api/' + url;
    //console.log(_url);

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem, tempoSpinner);
        }

        this.http.get(_url, { headers: header }).pipe(
          timeout(timeOut)
        )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {

            console.log('deu erro');
            if (err.status != 404) {
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            }

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err == "TimeoutError: Timeout has occurred") {
              if (loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                );
              }
            }

            //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
        )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  postLogChecklist(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...", timeOut: number = 45000, codigoLogin: string = ""): Promise<HttpResultModel> {

    // let _url = "https://dev-acampa-checklist.azurewebsites.net/" + 'api/' + url;
    let header;
    let _url;
    let options;

    header = this.createHeaderChecklist(new HttpHeaders(), codigoLogin);
    _url = ConfigHelper.Url + url;
    options = { headers: header};

    console.log('url savando',_url);

    return new Promise((resolve) => {

      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, options)
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }
            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {
            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            if (err.status == 403) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });
              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 400) {
              let msg = '';
              err.error.forEach(_err => {
                msg += `<li>${_err.retorno}</li>`;
              });

              this.alertSrv.newAlert('erro', msg);
            }
            else if (err.status == 200) {
              let msg = err.error.text;

              this.alertSrv.newAlert('erro',msg,'Problema ao Salvar',);
            }
            else {

              if (verconexao == 1 && loading == 1) {
                this.alertSrv.newAlert('erro','Sem conexão com o Servidor', 
                  '',
                  'Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!'
                  );
              }

              //this.alertSrv.toast('Não foi possível realizar o processamento da informação, verifique sua conexão e tente novamente', 'bottom');
            }

            resolve({ success: false, data: undefined, err: err });
          });
      }
      else {
        if (verconexao == 1) {
          this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
            "",
            "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
          )
        }

        resolve({ success: false, data: undefined, err: undefined });

      }
    });
  }


  postAgendamentoIA(url: string, model: any, loading: number = 1, verconexao: number = 1, mensagem: string = "Carregando os dados...", alerta_sem_conexao: boolean = true, tentativas: number = 3, timeOut: number = 30000,apiURL: boolean = true,codigoLogin: string = ""): Promise<HttpResultModel> {

    let header;
    let _url;
    let options;
    if(apiURL){
      header = this.createHeaderChecklist(new HttpHeaders(), codigoLogin);
      _url = ConfigHelper.Url + url;
      options = { headers: header};
    } else {
      header = this.createHeaderAgendamento();
      _url = ConfigHelper.Url + url;
      options = { headers: header, responseType: "blob"};
    }

    return new Promise((resolve) => {
      if (this.networkSrv.IsOnline) {

        if (loading == 1) {
          this.spinnerSrv.Show(mensagem);
        }

        this.http.post(_url, model, options)
          .pipe(
            timeout(timeOut)
          )
          .subscribe(_res => {

            if (loading == 1) {
              this.spinnerSrv.Hide();
            }

            //let json = JSON.parse(_res.data);
            resolve({ success: true, data: _res, err: undefined });
          }, err => {


            this.contador += 1;
            if (this.contador < tentativas) {
              return resolve(this.postAgendamentoIA(url, model, loading, verconexao,"Reconectando " + this.contador + "...",alerta_sem_conexao));
            }


            if (this.contador >= tentativas) {
              this.contador = 0;
              if (loading == 1) {
                console.log("alerta_sem_conexao", alerta_sem_conexao)
                if(alerta_sem_conexao)  this.alertSrv.newAlert('erro','Sem conexão com o Servidor', '','Infelizmente os dados não podem ser carregados do servidor, verifique sua internet ou tente novamente mais tarde!');
  
                this.spinnerSrv.Hide();
              }
              //this.alertSrv.toast('Não foi possível consultar os dados, verifique sua conexão e tente novamente', 'bottom');
              resolve({ success: false, data: undefined, err: err });
            }
          });
      }
      else {
        this.alertSrv.newAlert("erro","Sem conexão com o Servidor", 
          "",
          "Você está Offline, e infelizmente os dados não podem ser carregados do servidor!"
        )
        resolve({ success: false, data: undefined, err: undefined });
      }
    });
  }

  // getNativo(url: string, loading:number = 1, mensagem: string = "Carregando os dados...", tempo: number = null): Promise<HttpResultModel> 
  // {
  //   let _url = ConfigHelper.Url + url;
  //   //console.log(_url);
  //   return new Promise((resolve) => {
  //     this.httpNativo.get(_url, {},{'token': ConfigHelper.Token})
  //     .then(response => {
  //         //console.log('Serviço disponivel', response.data);
  //         //console.log(response);
  //         resolve({ success: true, data: JSON.parse(response.data), err: undefined });
  //     })
  //     .catch(error => {
  //       //console.log('Serviço indisponivel');
  //       //console.log("error:", error);
  //       //console.log("status:", error.status);
  //       //console.log("descritivo:", error.error);
  //       //console.log("headers:", error.headers);
  //       resolve({ success: false, data: error.error, err: undefined });

  //     })
  //   })
  // }
}


// WEBPACK FOOTER //
// ./src/providers/http/http.ts